"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Snackbar = void 0;
var React = _interopRequireWildcard(require("react"));
var _types = require("./types");
var _utils = require("../utils");
var _ui = require("../../ui");
require("../../../src/ui/snackbar/snackbar.module.scss");
const _excluded = ["className", "buttons", "icon", "text", "timer", "title", "variant", "onTimer", "position"],
  _excluded2 = ["isPrimary", "text", "icon"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
// accessibility ok

const Snackbar = props => {
  let {
      className,
      buttons,
      icon,
      text,
      timer,
      title,
      variant,
      onTimer,
      position
    } = props,
    attributes = _objectWithoutProperties(props, _excluded);
  let xlink = icon === null && variant !== 'undo' ? _types.ISnackbarDefaultIcons[variant] : icon;
  if (['timer', 'undo'].includes(variant) && timer === null) timer = 10;
  let buttonsGroup = [],
    buttonsGroupDiv = null;
  if (buttons) {
    buttonsGroup = buttons.map((item, key) => {
      let {
          isPrimary,
          text,
          icon
        } = item,
        attributes = _objectWithoutProperties(item, _excluded2);
      const buttonClassName = (0, _utils.ClassNames)('kui-snackbar__button', isPrimary ? 'kui-snackbar__button--primary' : null);
      const variant = icon ? 'icon' : 'primary';
      const children = icon ? /*#__PURE__*/React.createElement(_ui.Icon, {
        size: 16,
        xlink: icon
      }) : text;
      return /*#__PURE__*/React.createElement(_ui.Button, _extends({
        className: buttonClassName,
        color: !icon ? 'white' : null,
        key: key,
        variant: variant
      }, attributes), children);
    });
    buttonsGroupDiv = /*#__PURE__*/React.createElement(_ui.ButtonsGroup, {
      className: "kui-snackbar__buttons"
    }, buttonsGroup);
  }
  const refSnackbar = React.useRef(null);
  const [timerHook, setTimerHook] = React.useState(timer);
  const [timeoutHook, setTimeoutHook] = React.useState(null);
  const [s] = React.useState({});
  const [getTimerHook] = React.useState(() => () => s.timerHook);
  s.timerHook = timerHook;
  React.useEffect(() => {
    if (attributes.onBlur) {
      refSnackbar.current.focus();
    }
    let unmounted = false;
    if (timerHook === null) return;
    setTimeoutHook(setInterval(() => {
      if (unmounted) return;
      if (getTimerHook() < 1) {
        if (onTimer) onTimer();
        clearInterval(timeoutHook);
      } else {
        setTimerHook(getTimerHook() - 1);
      }
    }, 1000));
    return () => {
      unmounted = true;
      clearInterval(timeoutHook);
    };
  }, []);
  className = (0, _utils.ClassNames)('kui-snackbar', 'kui-snackbar--variant_' + variant, !title ? 'kui-snackbar--notitle' : null, variant === 'undo' && timerHook < 3 ? 'kui-snackbar--fadeout' : null, variant === 'undo' && timerHook <= 0 ? 'hidden' : null, className);
  const classContainer = (0, _utils.ClassNames)('kui-snackbar__container', position === 'left' ? 'kui-snackbar__container--left' : null);
  return /*#__PURE__*/React.createElement("div", {
    className: classContainer
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: className,
    ref: refSnackbar,
    tabIndex: 0,
    "aria-live": timer === timerHook ? 'assertive' : 'off' // при смене таймера скрин ридеру нужен только таймер
    ,
    role: 'alert'
  }, attributes), xlink && /*#__PURE__*/React.createElement(_ui.Icon, {
    xlink: xlink,
    size: 24,
    className: "kui-snackbar__icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "kui-snackbar__body"
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "kui-snackbar__title",
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), text && /*#__PURE__*/React.createElement("div", {
    className: "kui-snackbar__text",
    dangerouslySetInnerHTML: {
      __html: text
    }
  })), variant === 'timer' && /*#__PURE__*/React.createElement("div", {
    className: "kui-snackbar__timer",
    "aria-live": 'assertive'
  }, /*#__PURE__*/React.createElement("span", {
    className: "kui-snackbar__timer_num"
  }, timerHook), " sec"), buttonsGroupDiv));
};
exports.Snackbar = Snackbar;
Snackbar.defaultProps = {
  buttons: null,
  icon: null,
  text: null,
  timer: null,
  title: null,
  variant: 'info',
  position: 'center',
  onBlur: null,
  onTimer: () => undefined
};
Snackbar.displayName = 'Snackbar';